(function () {
  function iniciar(c) {
    if (c.dataset.scListo) return;
    c.dataset.scListo = '1';
    var pista = c.querySelector('.sc-carousel__track');
    var vista = c.querySelector('.sc-carousel__viewport');
    if (!pista || !vista || !pista.children.length) return;
    var indice = 0;
    var reloj = null;
    var segundos = parseFloat(c.dataset.speed) || 3;
    var automatico = c.dataset.mode === 'autoplay';
    var quieto = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    function paso() {
      var hueco = parseFloat(getComputedStyle(pista).columnGap) || 0;
      return pista.children[0].getBoundingClientRect().width + hueco;
    }
    function ultimo() {
      var visibles = Math.max(1, Math.round(vista.clientWidth / paso()));
      return Math.max(0, pista.children.length - visibles);
    }
    function ir(n) {
      var fin = ultimo();
      indice = n > fin ? 0 : n < 0 ? fin : n;
      pista.style.transform = 'translate3d(' + -(paso() * indice) + 'px,0,0)';
    }
    function parar() {
      if (reloj) clearInterval(reloj);
      reloj = null;
    }
    function arrancar() {
      parar();
      if (automatico && !quieto && ultimo() > 0) {
        reloj = setInterval(function () { if (!document.hidden) ir(indice + 1); }, segundos * 1000);
      }
    }
    var previo = c.querySelector('[data-sc-prev]');
    var siguiente = c.querySelector('[data-sc-next]');
    if (previo) previo.addEventListener('click', function () { ir(indice - 1); arrancar(); });
    if (siguiente) siguiente.addEventListener('click', function () { ir(indice + 1); arrancar(); });
    var inicioX = null;
    pista.addEventListener('pointerdown', function (e) { inicioX = e.clientX; parar(); });
    window.addEventListener('pointerup', function (e) {
      if (inicioX === null) return;
      var d = e.clientX - inicioX;
      inicioX = null;
      if (Math.abs(d) > 40) ir(indice + (d < 0 ? 1 : -1));
      arrancar();
    });
    window.addEventListener('resize', function () { ir(Math.min(indice, ultimo())); });
    arrancar();
  }
  function todo() {
    document.querySelectorAll('[data-sc-carousel]').forEach(iniciar);
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', todo);
  else todo();
  document.addEventListener('shopify:section:load', todo);
})();
